export default __webpack_public_path__ + "static/media/event-analysis.0a33b8e8.svg";